import { render, staticRenderFns } from "./UploadButton.vue?vue&type=template&id=3c536ba2"
import script from "./UploadButton.vue?vue&type=script&lang=js"
export * from "./UploadButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports